export const getPaginationContainerStyle = () => ({
  display: "flex",
  justifyContent: "center",
  background: "#EAF1EA",
  paddingY: "32px",
  "& .Mui-selected": {
    background: "#6bb4ad",
    backgroundColor: "#6bb4ad",
  },
});
